import React from 'react'
// import Dashboard1 from './dashboard1';F
import Dashboard2 from './dashboard2.js';
import DashBoard4 from './ptlConsignmentChartComponent.js'
// import IOCLChart from '../billing/IOCLChart.js';
import TrendChart from './mytrendchart.js'
import ConsignmentChart from "./consignmentChart.js";
// import Dashboard4 from './pendingwithtptchart.js';
import Tptperformancechart from "./tptperformancechart"
import Warehouseperformancechart from "./warehouseperformancechart";

const SummaryDashboard=() =>{
  return (
    <>
      <div className='col-sm-12' style={{paddingBottom:"25px"}}>
          <h5 style={{fontWeight: "bold", fontSize: "25px", margin: "12px"}}>Dashboard</h5>
          <div className='row mt-20p'>
            <div className='col-sm-6 col-md-6 col-xs-6 col-lg-6'>
              <Dashboard2 />
            </div>
            <div className='col-sm-6 col-md-6 col-xs-6 col-lg-6'>
              <DashBoard4 />
            </div>
            {/* <div className='col-6'>
              <ConsignmentChart/>
            </div>  */}
            {/* <div className='col-6'>
              <TrendChart/>
            </div> */}
            {/* <div className='col-6'>
              <Warehouseperformancechart/>
            </div>  */}
            {/* <div className='col-6'>
              <Dashboard4/>
            </div>   */}
            {/* <div className='col-6'>
              <Tptperformancechart/>
            </div> */}
          </div>
      </div>
    </>
  )
}

export default SummaryDashboard;
